import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroRecepciones= async (fechaStart,fechaEnd , idDropoff) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/recepcion?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idDropoff=${idDropoff}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroRecepcion = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/recepcion', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroRecepcion = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/recepcion/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroRecepcion = (Id) => Axios.delete(`/recepcion/${Id}`);